module.exports = __webpack_public_path__ + "static/img/far3_active.b69d9e5d.png";